import React, { Component } from 'react';
import * as Common from '../../helpers/Common';
import * as Config from '../../config/Config';

const $= window.$;
const jQuery=window.jQuery;

class IseekOthers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,

		 };
		
		this.close_popup = this.close_popup.bind(this);
		this.getCheck = this.getCheck.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
	}

	getCheck(){
		var checkedValues = $('.chk_slct:checked').map(function() {
			return this.value;
		}).get();
		//alert(checkedValues);
	    // var values = checkedValues.split('_');
	    // values = (values[1])+values[2];
		this.props.sendEmails(checkedValues);
	 //    this.setState({
		// 	checkedValues: checkedValues
		// });
	    // this.getData();

	}

	// getData(){
	// 	var emails = this.state.checkedValues;
	// 	//alert(emails);

	// }


	close_popup(e){
		//$('#close_modal').click();
		$("#window_trans1").css('display','none');
		$("#popup_window").css('display','none');


	}

	 

		toggleModal(){
			
			
			let learnerID = Common.getUserData("id", true);
			
			window.swal({
			    //title: 'Add new contact',
			      showCancelButton: true,
				  confirmButtonText: 'Submit',
				  animation: false,
				  showLoaderOnConfirm: true,
  
			    html:
			    	'<form id="assessor_add_form" name="assessor_add_form"  class="assessor_add_form">' +
			    	'<input type="hidden"  name="others_learner_id" id="others_learner_id"  className="swal2-input txtbox" value="" />' +
					'<input type="text"  name="others_name" placeholder="Name"  class="swal2-input txtbox" autofocus />' +
					'<input type="text"  name="others_email" placeholder="Email"   class="swal2-input txtbox"  />' +
			      '</form>',
			    preConfirm: () => {
			    	// const values = [];
			    	//alert(learnerID);	
			    	$("#others_learner_id").val(learnerID);
			    	let formData = new FormData();
				    //let details = [];
			      	$.each($('#assessor_add_form').serializeArray(), (i, field) => 
			      			//details.push({[field.name]:field.value})
			      			formData.append(field.name,field.value)
				           );
			    	return Promise.resolve(formData)
			    },
			    allowOutsideClick: true
			  })
			  .then((result) =>{
			  	if(result){
			  		fetch(Config.domainUrl +"iseek-others", {
			        method: "POST",
			        //data: formData,

			       headers: {
			           'Accept': 'application/json',
					   'Authorization':'Bearer ' +Common.getTokenData()
			           //'Content-Type': 'application/json'
			          },
			        body: result,
			       }).then((response) => response.json()).then((responseJson) => {
			       		if (responseJson.status == 0) {
					        Common.message(responseJson.message, responseJson.errors, "error");
					      } else {
					        Common.message("", responseJson.message, "success");
				       			 this.props.getSeekTables();
					      }
			       		
			       });
			  	}
			  });

		

			


		}





		render() {


			// alert(JSON.stringify(this.state.checkedValues));
        	let learnerID = Common.getUserData("id", true);
			const {Others} = this.props;
			let rows  = [];
			if(Others != undefined || Others != null){
				 rows = Others.map((other,i) => {
				 	var value = i+1;
	                return (
			                   <tr key={i}>
				                   	<td><input type="checkbox" name={"chkAssessor_id"+value} id={"chkAssessor_id"+value} value={'OT_'+other.snap_others_id_pk+'_'+other.others_name+'_'+other.others_email} className="chk_slct" onClick={(e)=>this.getCheck(e)} /></td>
					                <td>{other.others_name}</td>
					                <td>{other.others_email}</td>
			                   </tr>
			                )
			       });
			}

		       (rows.length == 0) ? rows = <tr align="center"><td colSpan="3">No contacts found.</td></tr> : rows = rows

			return (
				<div>

					<table  width="100%" border="1" style={{border: 'solid 1px #e7e7e7'}}>
			            <thead>
			              <tr>
			                <th></th>
			                <th align="left"><strong>Name</strong></th>
			                <th align="left"><strong>Email</strong></th>
			              </tr>
			            </thead>

					  	<tbody>
					  		{rows}
					  		 <tr align="center">
				            <td colSpan="3" align="left">
				              <a href="javascript:void(0);" onClick={this.toggleModal}><b>Add new contacts</b></a>
				            </td>
				          </tr>
					  	</tbody>
					</table>
					
				</div>
			);
		}
}

export default IseekOthers;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/IseekOthers.js